


























































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Equipment from "../../../store/entities/equipment";
@Component
export default class CreatEquipments extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  equipment: Equipment = new Equipment();
  selfloorlist = [];
  selwarehouselist = [];
  updateThreshold = false;
  updateTempHumi = false;
  updateEqutime = false;
  updateTimer1 = false;
  updateTimer2 = false;
  updateIanport = false;
  updateWorkMode = false;
  upgrade = false;
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.updateThreshold = false;
      this.updateTempHumi = false;
      this.updateEqutime = false;
      this.updateTimer1 = false;
      this.updateTimer2 = false;
      this.updateIanport = false;
      this.updateWorkMode = false;
      this.upgrade = false;
    }
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
  get threshold() {
    //console.log(this.$store.state.threshold.list);
    return this.$store.state.threshold.list;
  }
  selfactory(value: number) {
    this.equipment.ftId = value;
    if (value != 0 && value != undefined) {
      this.getselwarehouse();
    }
  }
  selwarehouse(value: number) {
    this.equipment.wId = value;
    if (value != 0 && value != undefined) {
      this.getselfloor();
    }
    // this.getfloor();
  }
  selfloor(value: number) {
    this.equipment.fId = value;
  }
  async getselwarehouse() {
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.equipment,
    });
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.equipment,
    });
  }
  save() {
    (this.$refs.equipmentForm as any).validate(async (valid: boolean) => {
      if (valid) {
        var dates = new Date();
        if (this.updateThreshold == true) {
          this.equipment.updateThreshold = 1;
          this.updateThreshold = false;
        }
        if (this.updateTempHumi == true) {
          this.equipment.updateTempHumi = 1;
          this.updateTempHumi=false;
        }
        if (this.updateEqutime == true) {
          this.equipment.updateEqutime = 1;
          this.updateEqutime=false;
        }
        if (this.updateTimer1 == true) {
          this.equipment.updateTimer1 = 1;
          this.updateTimer1=false;
        }
        if (this.updateTimer2 == true) {
          this.equipment.updateTimer2 = 1;
          this.updateTimer2=false;
        }
        if (this.updateIanport == true) {
          this.equipment.updateIanport = 1;
          this.updateIanport=false;
        }
        if (this.updateWorkMode == true) {
          this.equipment.updateWorkMode = 1;
          this.updateWorkMode=false;
        }
        if (this.upgrade == true) {
          this.equipment.upgrade = 1;
          this.upgrade=false;
        }
        if (this.equipment["equtime"] == "") {
          this.equipment["equtime"] = dates.toLocaleDateString();
        }
        await this.$store.dispatch({
          type: "equipment/create",
          data: this.equipment,
        });
        (this.$refs.equipmentForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.equipmentForm as any).resetFields();
    this.$emit("input", false);
  }
  equipmentRule = {
    wId: [
      {
        type: "number",
        required: true,
        message: "请选择库房",
        trigger: "change",
      },
    ],
    ftId: [
      {
        type: "number",
        required: true,
        message: "请选择库区",
        trigger: "change",
      },
    ],
    mac: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [
      {
        type: "number",
        required: true,
        message: "请选择楼层",
        trigger: "change",
      },
    ],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    numbler: [{ required: true, message: "请填写位置编号", trigger: "blur" }],
    //tId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
  };
}
